export default "__VITE_ASSET__DDAO5gqY__"